import { Children } from 'react';
import { PaperProps } from '@mui/material';
import Paper from '../../../Paper';
import {
  AB3, S1, S2, S3, S5,
} from '../../../../theme';
import { IAutocompleteProps } from '../../index';
import Box from '../../../Box';
import Typography from '../../../Typography';
import { mergeSX } from '../../../../services/helpers';

const DEFAULT_OPTION_STYLES = {
  minHeight: '56px',
  padding: '16px 24px',
};

interface IBuildSXParams extends Pick<IAutocompletePaperProps, 'withLabel'> {}

const buildSX = ({ withLabel }: IBuildSXParams) => ({
  '&.MuiAutocomplete-paper': {
    marginTop: '4px',
    marginBottom: withLabel ? '8px' : '4px',
    background: S1,
    border: `2px solid ${S3}`,
    borderRadius: '16px',
    '.MuiAutocomplete-listbox': {
      maxHeight: '280px',
      padding: 0,
      '.MuiAutocomplete-option': {
        ...DEFAULT_OPTION_STYLES,
        color: AB3,
        wordBreak: 'break-all',
      },
      '.MuiAutocomplete-option.Mui-focused': { // hover
        background: S2,
      },
      '.MuiAutocomplete-option[aria-selected=true]': {
        background: AB3,
        color: S1,
      },
    },
    '.MuiAutocomplete-noOptions, .MuiAutocomplete-loading': {
      ...DEFAULT_OPTION_STYLES,
      color: AB3,
      boxSizing: 'border-box',
    },
  },
});

const BOX_SX = { borderTop: `2px solid ${S3}` };

interface IAutocompletePaperProps extends PaperProps,
    Pick<IAutocompleteProps, 'loadedOptionsCount' | 'totalLoadedOptionsCount' | 't'> {
  withLabel: boolean;
  areOptionsLoading: boolean;
}

const AutocompletePaper = (props: IAutocompletePaperProps) => {
  const {
    children,
    loadedOptionsCount,
    totalLoadedOptionsCount,
    withLabel,
    areOptionsLoading,
    t,
    sx,
    ...rest
  } = props;
  if (Children.toArray(children).every((child) => !child)) {
    return null;
  }

  return (
    <Paper elevation={0} sx={mergeSX(buildSX({ withLabel }), sx)} {...rest}>
      {children}
      {!!loadedOptionsCount && !!totalLoadedOptionsCount && !areOptionsLoading && !!t && (
        <Box p={2} sx={BOX_SX}>
          <Typography variant="body2" color={S5} align="right">
            {t('autocomplete.optionsInfo', {
              count: loadedOptionsCount, totalCount: totalLoadedOptionsCount,
            })}
          </Typography>
        </Box>
      )}
    </Paper>
  );
};

export default AutocompletePaper;
